import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
  refresh: () => api.post('/auth/refresh'),
  updateProfile: (data) => api.put('/auth/profile', data),
  googleSession: (sessionId) => api.post('/auth/google/session', { session_id: sessionId }),
  googleLogout: () => api.post('/auth/google/logout'),
  premiumStatus: () => api.get('/auth/premium-status'),
};

// Listings
export const listingsAPI = {
  getAll: (params) => api.get('/listings', { params }),
  getOne: (id) => api.get(`/listings/${id}`),
  create: (data) => api.post('/listings', data),
  update: (id, data) => api.put(`/listings/${id}`, data),
  delete: (id) => api.delete(`/listings/${id}`),
  promote: (id, originUrl) => api.post(`/listings/${id}/promote`, { origin_url: originUrl }),
};

// Upload
export const uploadAPI = {
  image: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

// Payments
export const paymentsAPI = {
  getStatus: (sessionId) => api.get(`/payments/status/${sessionId}`),
};

// Messages
export const messagesAPI = {
  send: (data) => api.post('/messages', data),
  getAll: () => api.get('/messages'),
  markRead: (id) => api.put(`/messages/${id}/read`),
};

// Favorites
export const favoritesAPI = {
  getAll: () => api.get('/favorites'),
  add: (listingId) => api.post(`/favorites/${listingId}`),
  remove: (listingId) => api.delete(`/favorites/${listingId}`),
};

// Meta
export const metaAPI = {
  getCategories: () => api.get('/categories'),
  getBrands: () => api.get('/brands'),
  getCountries: () => api.get('/countries'),
  getStats: () => api.get('/stats'),
};

// Users
export const usersAPI = {
  getProfile: (id) => api.get(`/users/${id}/profile`),
};

// Referral
export const referralAPI = {
  getMy: () => api.get('/referral/my'),
};

export default api;
